(function() {
  var store;
  store = window.Store || (window.Store = {});
  store.Views = store.Views || (store.Views = {});
  store.Views.HeaderView = Backbone.View.extend({
    events: {
      'mouseover nav': 'navActions',
      'mouseout nav': 'navActions',
      'mouseout #cart': 'cartActions',
      'mouseover #cart': 'cartActions'
    },
    anim: {
      speed: 300,
      ease: 'easeInOutQuint'
    },
    initialize: function(options) {
      this.options = options;
      this.elements = {
        $nav: this.$('nav'),
        $cart: this.$('#cart')
      };
    },
    cartActions: function(e) {
      return;
      if (e.type === 'mouseover') {
        this.elements.$cart.animate({
          height: 200
        }, this.anim.speed, this.anim.ease);
      } else if (e.type === 'mouseout') {
        this.elements.$cart.animate({
          height: 40
        }, this.anim.speed, this.anim.ease);
      }
    },
    navActions: function(e) {
      return;
      if (e.type === 'mouseover') {
        this.elements.$nav.animate({
          height: 200
        }, this.anim.speed, this.anim.ease);
      } else if (e.type === 'mouseout') {
        this.elements.$nav.animate({
          height: 40
        }, this.anim.speed, this.anim.ease);
      }
    }
  });
}).call(this);
